export class RouteInformation{
    routeCode: string;
    routeName: string;
    fromLocationGroup: string;
    toLocationGroup: string;
}